import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-79c1fa5c")

_pushScopeId("data-v-79c1fa5c")
const _hoisted_1 = {
  key: 0,
  class: "custom-icon flex flex--width flex--height flex--valign-c flex--halign-c"
}
const _hoisted_2 = { class: "text text--size-72 text--color-white text--bold text--shadow" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_svg_vue = _resolveComponent("svg-vue")

  return (_ctx.identifier)
    ? (_openBlock(), _createBlock("div", {
        key: 0,
        class: ["icon", { 'searching-icon': _ctx.searching }]
      }, [
        (_ctx.identifier.includes('arrow'))
          ? (_openBlock(), _createBlock("div", _hoisted_1, [
              _createVNode("span", _hoisted_2, _toDisplayString(_ctx.identifier === "arrow_left" ? "<" : ">"), 1)
            ]))
          : (_ctx.identifier === 'djf_search')
            ? (_openBlock(), _createBlock(_component_svg_vue, {
                key: 1,
                icon: _ctx.identifier
              }, null, 8, ["icon"]))
            : (_ctx.url)
              ? (_openBlock(), _createBlock("img", {
                  key: 2,
                  class: "icon-img",
                  src: _ctx.url
                }, null, 8, ["src"]))
              : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
})